import React from 'react';

import PackageDefs from '~app/pages/Pricing/lib/packages/packageDefs';
import { PackageDefs as Grow2792PackageDefs } from '../../constants';
import PackageHeader from '~pricing/experiments/grow_2792_pnp_refresh_v1/components/PackageHeader';
import { PackageHeaderProps } from '~pricing/components/Summary/types';

import useDetailsPackageHeaderStyles from './useStyles';

type DetailsHeader = {
  index: string;
};

type DetailsPackageHeaderProps = PackageHeaderProps & DetailsHeader;

const expPackageDefs = { ...PackageDefs, ...Grow2792PackageDefs };

export default function DetailsPackageHeader({
  comparisonSkuCosts,
  discountInfo,
  skuCosts,
  packageName,
  index,
}: DetailsPackageHeaderProps): JSX.Element {
  const { Highlighted, Package } = useDetailsPackageHeaderStyles({ packageName });

  return (
    <div
      className={`${Package} ${expPackageDefs[packageName]?.highlighted ? Highlighted : ''}`}
      style={{ gridArea: `package${index}` }}
    >
      <PackageHeader
        comparisonSkuCosts={comparisonSkuCosts}
        discountInfo={discountInfo}
        skuCosts={skuCosts}
        packageName={packageName}
      />
    </div>
  );
}
